"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AMSFilePermissions = /** @class */ (function () {
    function AMSFilePermissions() {
    }
    AMSFilePermissions.read = "read";
    return AMSFilePermissions;
}());
exports.default = AMSFilePermissions;
//# sourceMappingURL=AMSFilePermissions.js.map